import React from "react";
import { AppBar, Box, Container, Link, Stack, Toolbar, Typography, useTheme } from "@mui/material";
import Logo from "../App/assets/images/myownfp-logo.png";


export const TopBar = ({ text, children }) => {
    const theme = useTheme();
    return (
        <AppBar sx={{ bgcolor: "#000000", zIndex: (theme) => theme.zIndex.drawer + 1 }} position="sticky">
            <Container maxWidth="true">
                <Toolbar>

                    {/* <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} /> */}
                    <Link href="https://myownfp.ca">
                        <Stack direction="row" spacing={2}>
                            <Box
                                component="img"
                                sx={{
                                    height: 40,
                                }}
                                alt="MyOwnFP"
                                src={Logo}
                            />
                        </Stack>
                    </Link>
                    <Typography
                        variant="body"

                        sx={{
                            ml: 4,
                            py: 2,
                            mr: 4,
                            mt: -1,
                            //display: { xs: 'none', md: 'flex' },
                            fontFamily: 'Helvetica Neue',
                            color: '#ffffff',
                            textDecoration: 'none',
                        }}
                    >
                        {text}
                    </Typography>
                    {children}
                </Toolbar>
            </Container>
        </AppBar>
    )
}